export { ReactComponent as homeIcon } from './home.svg';
export { ReactComponent as homeActiveIcon } from './active/home-bottom-nav.svg';
export { ReactComponent as candlestickIcon } from './candlestick.svg';
export { ReactComponent as candlestickActiveIcon } from './active/candlestick-bottom-nav.svg';
export { ReactComponent as ticketSearchIcon } from './ticket-search.svg';
export { ReactComponent as ticketSearchActiveIcon } from './active/ticket-search-bottom-nav.svg';
export { ReactComponent as userIcon } from './user.svg';
export { ReactComponent as userActiveIcon } from './active/user-bottom-nav.svg';
export { ReactComponent as settingsIcon } from './settings.svg';
export { ReactComponent as settingsActiveIcon } from './active/settings-bottom-nav.svg';
